// this mocks `state.get("counter")` from notification-handler-store for the notification-bell story
//? see https://storybook.js.org/docs/writing-stories/mocking-data-and-modules/mocking-modules#mock-files
//? see https://storybook.js.org/blog/type-safe-module-mocking/

// import {fn} from "@storybook/test";
// import * as actual from "./notification-handler-store";

// export * from "./notification-handler-store";

// export const state = fn(actual.state).mockName("state");
